import app from 'flarum/forum/app';
import RegisterWidget from '../common/registerWidget';

app.initializers.add('tf-carousel-widget', () => {
  RegisterWidget(app);
});
